import { render } from "./FormSign.vue?vue&type=template&id=71c98efd&scoped=true"
import script from "./FormSign.vue?vue&type=script&lang=js"
export * from "./FormSign.vue?vue&type=script&lang=js"

import "./FormSign.vue?vue&type=style&index=0&id=71c98efd&scoped=true&lang=css"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\sport.yanhuotiyu.com焱火pc端web网站\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71c98efd"]])

export default __exports__